import { TICKET_STATUS_CARD_STYLES, TicketStatus, TicketUrgency } from 'data/constants/constants';

export const TICKET_STATUS_LABEL_KEYS: Record<string, string> = {
    [TicketStatus.PENDING]: 'ticketStatusPending',
    [TicketStatus.IN_REVIEW]: 'ticketStatusInReview',
    [TicketStatus.RESOLVED]: 'ticketStatusResolved',
    [TicketStatus.CLOSED]: 'ticketStatusClosed',
};

export const TICKET_URGENCY_LABEL_KEYS: Record<string, string> = {
    [TicketUrgency.LOW]: 'urgencyLow',
    [TicketUrgency.MEDIUM]: 'urgencyMedium',
    [TicketUrgency.HIGH]: 'urgencyHigh',
    [TicketUrgency.CRITICAL]: 'urgencyHigh',
};

export const getTicketStatusLabel = (status: string) =>
    TICKET_STATUS_CARD_STYLES[status]?.label ?? status;

export const getTicketStatusLabelKey = (status: string) =>
    TICKET_STATUS_LABEL_KEYS[status] ?? status;

export const getTicketUrgencyLabelKey = (urgency: string) =>
    TICKET_URGENCY_LABEL_KEYS[urgency] ?? urgency;

export const getTicketStatusColor = (status: string) =>
    TICKET_STATUS_CARD_STYLES[status]?.bg ?? '#F3F4F6';
